/*
 * localstorage或cache中存储时用到的key
 * 统一位置定义的好处：一目了然的知道当前系统中存在哪些key,以及他们的作用
 * 也有利于避免key值冲突
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-08-06 09:26:51
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-12-17 20:59:42
 */

const STORAGE = {
	USER: 'USER',  // 用户信息
	SHOP: 'SHOP',  // 当前选中的店铺
	BASIC_INFO: 'basic_info', // 基本信息
	CONTENT_SERVER: 'contentServer', // 内容服务器，用于上传图片
	STORE_CREATE_INFO: 'storeCreateInfo', //店铺创建信息，因分步创建，把表单信息放到cache中管理，创建成功后及时清除
};

export default STORAGE;
